import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Providers } from "@/providers";
import { App } from "@/App";
import "@/globals.css";
// Pixel-perfect skeleton bones captured via `npx boneyard-js build`. Registers
// <Skeleton name="…"> layouts so loading states match real DOM geometry.
import "@/bones/registry";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>
);
